import React, { useRef, useEffect } from 'react';

/**
 * Renders Quill-generated blog HTML with:
 *  - Custom db-* classes stamped onto table elements for styling
 *  - A functional COPY button injected into every code block
 */
function PostContent({ html, className }) {
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) return;

        // ── Stamp db-* classes onto table elements ────────────
        ref.current.querySelectorAll('table').forEach(el => el.classList.add('db-table'));
        ref.current.querySelectorAll('tr').forEach(el => el.classList.add('db-row'));
        ref.current.querySelectorAll('td').forEach(el => el.classList.add('db-cell'));
        ref.current.querySelectorAll('th').forEach(el => el.classList.add('db-header'));

        // ── Inject COPY button into each code block ───────────
        ref.current.querySelectorAll('.ql-code-block-container').forEach(container => {
            if (container.querySelector('.code-copy-btn')) return; // already injected

            const btn = document.createElement('button');
            btn.textContent = 'COPY';
            btn.className = 'code-copy-btn';

            btn.addEventListener('click', () => {
                const text = Array.from(container.querySelectorAll('div'))
                    .map(d => d.innerText ?? d.textContent)
                    .join('\n');
                navigator.clipboard.writeText(text).then(() => {
                    btn.textContent = 'COPIED!';
                    setTimeout(() => { btn.textContent = 'COPY'; }, 2000);
                });
            });

            container.appendChild(btn);
        });
    }, [html]);

    return (
        <div
            ref={ref}
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}

export default PostContent;
